var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, PacemEventTarget, PropertyChangeEventName, Components, PropertyConverters, Utils, ViewChild, Watch, UI, avoidHandler } from '@pacem/pacem-core';
import { PacemBaseElement } from './types-components';
/** For internal use ONLY! */
let PacemChildFormPropagatorElement = class PacemChildFormPropagatorElement extends PacemEventTarget {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            const prop = this.property, value = this.watch, hasPropDefined = !Utils.isNullOrEmpty(prop), hasModelDefined = !Utils.isNull(this.model);
            if (name === 'watch'
                || name === 'property'
                || (name === 'model' && hasPropDefined && hasModelDefined && Utils.isArray(val) && val.some(i => !(prop in i) || i[prop] !== value))
                || (name === 'model' && hasPropDefined && hasModelDefined && !Utils.isArray(val) && (!(prop in val) || val[prop] !== value))) {
                this._synchronize();
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._synchronize();
    }
    _synchronize() {
        const model = this.model, propagate = this.property, value = this.watch;
        if (Utils.isNullOrEmpty(model) || Utils.isNullOrEmpty(propagate)) {
            return;
        }
        if (Utils.isArray(model)) {
            for (let item of model) {
                item[propagate] = value;
            }
            // trigger change
            this.model = model.slice(0);
        }
        else {
            model[propagate] = value;
            // trigger change
            this.model = Utils.extend({}, model);
        }
    }
};
__decorate([
    Watch({ emit: true /* mandatory twoway binding */ })
], PacemChildFormPropagatorElement.prototype, "model", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String, reflectBack: true })
], PacemChildFormPropagatorElement.prototype, "property", void 0);
__decorate([
    Watch({ emit: false })
], PacemChildFormPropagatorElement.prototype, "watch", void 0);
PacemChildFormPropagatorElement = __decorate([
    CustomElement({ tagName: P + '-childform-propagator' })
], PacemChildFormPropagatorElement);
export { PacemChildFormPropagatorElement };
/** Represents a sub-form for automatic generation of editing fields for sub-entities.  */
let PacemChildFormElement = class PacemChildFormElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        /** Internal representation of the entity. */
        this._model = [];
        this._subForms = [];
    }
    get inputFields() {
        return [];
    }
    toggleReadonlyView(readonly) {
        // automatic
    }
    onChange(evt) {
        return new Promise((resolve, _) => {
            var val = this._modelToEntity();
            resolve(this.value = val);
        });
    }
    acceptValue(val) {
        this._entityToModel(val);
    }
    getViewValue(value) {
        return '';
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Json.convert(attr, this);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'mode':
                this._entityToModel();
                break;
        }
    }
    _dragStart(evt) {
        var args = evt.detail;
        const size = Utils.offset(args.element), floater = args.floater;
        floater.style.width = size.width + 'px';
        floater.style.height = size.height + 'px';
    }
    _dragEnd(evt) {
        if (this.mode === 'array' /*&& !Utils.isNull(evt.detail.target)*/) {
            this._triggerChange();
        }
    }
    reset() {
        super.reset();
        // once the value/entity with this component is reset
        // it is not necessary to process the subForms
        this._subForms.forEach(f => {
            f.setPristine();
        });
    }
    _itemCreate(evt) {
        const ndx = evt.detail.index, subForms = this._subForms;
        evt.detail.dom[0].childNodes.forEach(e => {
            if (e instanceof Element && e.localName === (P + '-form')) {
                subForms.splice(ndx, subForms.length - ndx, e);
            }
        });
    }
    _itemChange(ndx, evt) {
        if (evt.detail.propertyName === 'entity'
            && Utils.Json.stringify(this._model[ndx]) !== Utils.Json.stringify(evt.detail.currentValue)) {
            this._model.splice(ndx, 1, evt.detail.currentValue);
            this._triggerChange();
        }
    }
    _deleteAt(evt) {
        // prevent the event to bubble (nested scenarios).
        avoidHandler(evt.srcEvent);
        const model = this._model;
        if (this.mode === 'array') {
            model.splice(evt.detail, 1);
        }
        else {
            model.splice(0, model.length);
        }
        this._triggerChange();
    }
    _addItem(evt) {
        const mode = this.mode, model = this._model;
        if (mode === 'array') {
            model.push({});
        }
        else {
            model.splice(0, model.length, {});
        }
        this._triggerChange();
    }
    _triggerChange() {
        this.changeHandler(new Event('change'));
    }
    _entityToModel(entity = this.value) {
        switch (this.mode) {
            case 'array':
                let arr = entity || [];
                if (Utils.isArray(arr)) {
                    this._model.cloneFrom(arr);
                }
                break;
            default:
                const model = this._model, length = model.length;
                if (length !== 1 || model[0] !== entity) {
                    if (!Utils.isNull(entity)) {
                        model.splice(0, length, entity);
                    }
                    else {
                        model.splice(0, length);
                    }
                }
                break;
        }
    }
    _modelToEntity(model = this._model) {
        switch (this.mode) {
            case 'array':
                return Utils.clone(model);
            default:
                return model && model.length && model[0] || null;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemChildFormElement.prototype, "fetchCredentials", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemChildFormElement.prototype, "fetchHeaders", void 0);
__decorate([
    ViewChild('.' + PCSS + '-childform')
], PacemChildFormElement.prototype, "_container", void 0);
__decorate([
    ViewChild(P + '-drag-drop')
], PacemChildFormElement.prototype, "_dragger", void 0);
__decorate([
    ViewChild('.' + PCSS + '-childform-item-floater')
], PacemChildFormElement.prototype, "_floater", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemChildFormElement.prototype, "mode", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemChildFormElement.prototype, "lockItems", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemChildFormElement.prototype, "metadata", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemChildFormElement.prototype, "_model", void 0);
PacemChildFormElement = __decorate([
    CustomElement({
        tagName: P + '-childform', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater datasource="{{ :host._model }}" on-itemdelete=":host._deleteAt($event)" on-${Components.RepeaterItemCreateEventName}=":host._itemCreate($event)">
    <div class="${PCSS}-childform">
    <template>
        <${P}-panel class="${PCSS}-childform-item" behaviors="{{ [::_dragger] }}">
            <${P}-panel class="childform-item-handle ${PCSS}-margin margin-right-1" hide="{{ :host.lockItems || :host.readonly || :host.mode !== 'array' || !(:host._model && :host._model.length > 1) }}"><i class="${PCSS}-icon drag-handle">drag_handle</i></${P}-panel>
            <${P}-panel class="childform-item-index text-small"><${P}-span hide="{{ !:host.readonly || :host.mode !== 'array' }}" class="${PCSS}-margin margin-right-1" text="{{ ^index+1 }}"></${P}-span></${P}-panel>
            <${P}-form entity="{{ ^item }}" fetch-headers="{{ :host.fetchHeaders }}" fetch-credentials="{{ :host.fetchCredentials }}" on-${PropertyChangeEventName}=":host._itemChange(^index, $event)" readonly="{{ :host.readonly }}" metadata="{{ :host.metadata }}" autogenerate="true" logger="{{ :host.logger }}"></${P}-form>
            <${P}-button tab-order="-1" class="flat circular circle-small clear ${PCSS}-margin margin-left-1" hide="{{ :host.lockItems || :host.readonly }}" command-name="delete" command-argument="{{ ^index }}"></${P}-button>
        </${P}-panel>
    </template>
    </div>
    <${P}-button tab-order="-1" class="flat circular circle-small add" hide="{{ :host.lockItems || :host.readonly || !(:host.mode === 'array' || $pacem.isNullOrEmpty(:host._model)) }}" on-click=":host._addItem($event)"></${P}-button>
</${P}-repeater>
<div class="${PCSS}-childform-item-floater ${PCSS}-panel panel-border">
    <div class="corner top-left"></div><div class="corner top-right"></div><div class="corner bottom-left"></div><div class="corner bottom-right"></div>
</div>
<${P}-drag-drop floater="{{ ::_floater }}" disabled="{{ :host.lockItems }}"
    on-${UI.DragDropEventType.Start}=":host._dragStart($event)"
    on-${UI.DragDropEventType.End}=":host._dragEnd($event)" 
    drop-behavior="${UI.DropBehavior.InsertChild}" mode="${UI.DragDataMode.Alias}" handle-selector=".drag-handle" drop-targets="{{ [::_container] }}"></${P}-drag-drop>`
    })
], PacemChildFormElement);
export { PacemChildFormElement };
